import { render } from "./BusDeviceCardNew.vue?vue&type=template&id=670e41d6"
import script from "./BusDeviceCardNew.vue?vue&type=script&lang=js"
export * from "./BusDeviceCardNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__